<template>
<v-container fill-height fluid>
  <v-card
    class="mx-auto"
    max-width="900">
    <v-card-text>
      <h2 class="text-center mb-2">Health Protocol in Face-to-Face Session</h2>
      <p>Technical and Vocational Education and Training Centers may conduct face-to-face training and competency assessment provided that the health protocols listed below are strictly implemented.</p>
      <ol type="I" class="ma-3">
        <li>Mask should be used at all times in all public areas. Handwashing facilities and alcohol should be accessible to everyone;</li>
        <li>A distance of at least one meter from each other shall be implemented during meals and face-to-face classes;</li>
        <li>In no event can a class use more than 50% of the seating capacity of the classroom or venue. At all times, all chairs must at least be one meter apart;</li>
        <li>All activities where physical distancing cannot be complied with shall not be implemented.</li>
      </ol>
      <p class="font-italic">(Reference: Office of the City Mayor – Davao City Executive Order No. 47, series of 2020, Section 6. Educational Institutions, Item c and d.) </p>
    </v-card-text>
  </v-card>

</v-container>
</template>

<script>

export default {
  name: 'HealthPage',
}
</script>